import React from 'react';
import styles from './lines.module.scss';

const ProcessLineOne = ({ className }) => {
  return (
    <svg
      className={`${styles.line} ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      width="807.701"
      height="599.224"
      viewBox="0 0 807.701 599.224"
      preserveAspectRatio="none"
    >
      <path
        id="Path_359"
        data-name="Path 359"
        d="M588.463,420.381s-278.41-34.042-225.242,65.214,223.6,20.028,357.609,26.269,405.261,27.108,379.764,87.556-194.29,76.707-379.764,88.31-458.951-8.741-420.772,71.254,221.325,73.072,420.772,79.909,407.886,23.069,379.764,97.136-379.764,76.943-379.764,76.943"
        transform="translate(-295.956 -414.23)"
        fill="none"
        stroke="#893b2b"
        strokeWidth="1"
      />
    </svg>
  );
};

export default ProcessLineOne;
